module.exports = __webpack_public_path__ + "a5343217a44ab477a1b2774edfb27bcd.MP3";